import * as React from 'react';

import { useAuthUser } from 'hooks/useAuthUser';

import Alert from '@eduzz/fidc-alert';

const FIDCAlert = () => {
  const { data: user } = useAuthUser();

  if (!user) return null;

  return <Alert className='mb-4' eduzzId={user.cli_cod} userName={user.user_name} application='eduzz' />;
};

export default FIDCAlert;
